import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconMail = (props: IconProps) => (
  <svg
    className={cn(iconStyles(props))}
    width="25"
    height="20"
    viewBox="0 0 25 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      strokeWidth="1.8"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 18.11c0 .5-.38.89-.85.89H1.85a.87.87 0 01-.85-.89V1.9c0-.5.38-.89.85-.89h21.3c.47 0 .85.4.85.89v16.2z" />
      <path d="M24 1L12.5 12 1 1m14 9l9 9M1 18l9-8" />
    </g>
  </svg>
);
